import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M14.2485 7.72L20.7759 25.0003H18.1362L16.4185 20.2239H8.98193L7.26416 25.0003H4.76807L11.272 7.72H14.2485ZM9.7417 18.1116H15.6587L12.6997 9.88699L9.7417 18.1116Z M25.8745 25.0003H23.3306V7.72H25.8745V25.0003Z M32 0V32H0V0H32ZM2 30H30V2H2V30Z'],
  name: 'uiAI',
  pathProps: {"fillRule":"evenodd","clipRule":"evenodd"}
} as IconDefinition
